import styled from "styled-components";

export const ContainerResetPasswordHeader = styled.header`
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 0px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 712px;
  }

  @media (min-width: 1024px) {
    max-width: 976px;
  }

  @media (min-width: 1024px) {
    max-width: 1396px;
  }
`;

export const LogoResetPasswordPage = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const LogoResetPasswordPageColor = styled.span`
  color: #1ac63f;
`;

export const NameUserResetPassword = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.19;
  }
`;

export const NameUserResetPasswordColor = styled.span`
  color: #1ac63f;
`;

export const FormResetPassword = styled.form`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 16px 0px 16px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 112px;
  margin-bottom: 100px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin-top: 153px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    padding: 0px;
    margin-top: 243px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    margin-top: 106px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    margin-top: 183px;
  }
`;

export const FormContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 43px;
`;

export const EnterPasswordContainer = styled.div`
  max-width: 100%;
  position: relative;
`;

export const EnterPasswordButton = styled.button`
  position: absolute;
  right: 30px;
  top: 15px;

  @media (min-width: 428px) {
    right: 20px;
  }

  @media (min-width: 1440px) {
    top: 25px;
  }
`;

export const RepeatPasswordButton = styled.button`
  position: absolute;
  right: 30px;
  top: 45px;

  @media (min-width: 428px) {
    right: 20px;
  }

  @media (min-width: 1440px) {
    top: 55px;
  }
`;

export const PasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin-top: 30px;
`;

export const TitleResetPassword = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;

  @media (min-width: 744px) {
    font-size: 30px;
    font-weight: 500;
    line-height: 1.2;
  }
`;

export const PasswordInput = styled.input`
  width: 310px;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 18px 20px;
  color: #000;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;

  &::placeholder {
    color: #808080;
  }

  @media (min-width: 428px) {
    width: 356px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 408px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

// error password

export const ErrorText = styled.p`
  color: #f44336;
  font-size: 14px;
  margin-top: 4px;
  margin-left: 4px;
  min-height: 20px;
`;

export const PasswordRepeatInput = styled.input`
  width: 310px;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 18px 20px;
  color: #000;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  margin-top: 30px;

  &::placeholder {
    color: #808080;
  }

  @media (min-width: 428px) {
    width: 356px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 408px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const PasswordInputInclude = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 30px;
    font-weight: 500;
    line-height: 1.2;
  }
`;

export const PasswordSymbolsText = styled.span`
  font-size: 24px;
  font-weight: 300;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 30px;
    font-weight: 300;
    line-height: 1.2;
  }
`;

export const PasswordButtonSave = styled.input`
  background: #1ac63f;
  border-radius: 20px;
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.2;
  padding: 17px 0;
  cursor: pointer;
  margin-top: 50px;

  @media (min-width: 744px) {
    font-size: 30px;
    font-weight: 300;
    line-height: 1.2;
  }
`;
